<template>
  <vertical-modal
    :visible="openModal" @close="close"
    :header-title="'جزئیات پرداختنی ' + props.payment_able_selected?.id"
    header-icon="info-bold"
    body-class="tw-bg-gray-100"
    footer-class="tw-justify-between"
    width="md">
    <template #body>
      <div class="md:tw-grid ltr tw-overflow-y-auto md:tw-grid-cols-[385px_1fr] tw-h-full tw-gap-0">
        <!--   Left Side   -->
        <div class="rtl tw-bg-white tw-border-r tw-border-blue-dark-50 tw-text-blue-dark-500 tw-h-auto md:tw-h-full tw-overflow-y-auto">
          <!--   Amount Payment-able Detail   -->
          <div class="tw-relative tw-border-b tw-border-blue-dark-50 tw-p-6 tw-pb-[28px]">
            <div class="tw-flex tw-justify-between tw-mb-4">
              <h4 class="tw-font-bold tw-text-base">مبلغ قابل پرداخت</h4>
              <shine-loading body_width="60" v-if="loading || loading_get_balance" />
              <span v-else :class="[
                'tw-text-xs',
                props.payment_able_selected?.cancel && 'tw-text-red-600',
                (!props.payment_able_selected?.payed && !props.payment_able_selected?.cancel) && 'tw-text-blue-dark-200',
                (props.payment_able_selected?.payed && !props.payment_able_selected?.cancel) && 'tw-text-green-600',
              ]">
              <base-icon v-if="props.payment_able_selected?.cancel" icon="cancel" size="20" class="tw-pl-3 tw-align-middle" />
              <base-icon v-else-if="!props.payment_able_selected?.payed" icon="history-toggle-off" size="20" class="tw-pl-3 tw-align-middle" />
              <base-icon v-else-if="props.payment_able_selected?.payed" icon="check-circle" size="20" class="tw-pl-3 tw-align-middle" />
                {{ props.payment_able_selected?.status_title || '-/-'}}
              </span>
            </div>
            <div class="tw-inline-block">
              <base-icon icon="universal-currency" class="tw-pl-4 tw-align-middle" />
              <shine-loading v-if="loading || loading_get_balance" body_width="60" class="tw-inline-block tw-align-middle" />
              <span v-else class="tw-inline-block tw-text-regular">{{ new Intl.NumberFormat().format(amount_pay) }} ریال</span>
            </div>


            <div class="tw-absolute tw-inset-0 tw-flex tw-justify-center tw-items-end tw-select-none">
              <base-icon icon="expand-circle-up-bold"
                         size="32"
                         v-if="showMoreDetail"
                         @click="showMoreDetail = false"
                         class="tw-bg-white tw-text-blue-dark-400 tw--mb-[16px] tw-text-2xl tw-cursor-pointer" />

              <base-icon icon="expand-circle-down"
                         v-else
                         size="32"
                         @click="showMoreDetail = true"
                         class="tw-bg-white tw-text-blue-dark-400 tw--mb-[16px] tw-text-2xl tw-cursor-pointer" />
            </div>
          </div>

          <!--   Pricing Detail   -->
          <transition name="price-detail" mode="out-in">
            <div class="tw-border-b-[3px] tw-border-blue-dark-50" v-show="showMoreDetail">
              <div class="tw-flex tw-justify-between tw-py-3 tw-px-6 tw-border-b tw-border-dashed tw-border-gray-500">
                <span class="tw-text-tiny">مبلغ</span>
                <div>
                  {{ new Intl.NumberFormat().format(props.payment_able_selected?.amount || 0) }} ریال
                </div>
              </div>
              <div class="tw-flex tw-justify-between tw-py-3 tw-px-6 tw-border-b tw-border-dashed tw-border-gray-500">
                <span class="tw-text-tiny">اسناد در انتظار پرداخت</span>
                <div>
                  <shine-loading body_width="70" v-if="sum_payment_able_amount_loading" />
                  <template v-else>
                    <base-icon icon="info" class="tw-text-blue-dark-300 tw-pl-2 tw-align-middle" size="20" />
                    <div class="tw-inline-block">
                      {{ toNumberFormat(props.payment_able_selected?.payed ? (props.payment_able_selected.current_sum_amount_creditorable || 0) : sum_payment_able_amount) }}
                      ریال
                    </div>
                  </template>
                </div>
              </div>
              <div class="tw-flex tw-justify-between tw-py-3 tw-px-6 tw-border-b tw-border-dashed tw-border-gray-500">
                <span class="tw-text-tiny">مانده فرامحاسب</span>
                <div>
                  <shine-loading body_width="80" v-if="loading_get_balance" />
                  <debit-credit-display v-else-if="props.payment_able_selected?.payed" :amount="props.payment_able_selected.current_fm_mandeh || 0" />
                  <debit-credit-display v-else-if="code_balance" :amount="code_balance" />
                </div>
              </div>
              <div class="tw-flex tw-justify-between tw-py-3 tw-px-6 tw-border-b tw-border-dashed tw-border-gray-500">
                <span class="tw-text-tiny">مانده نهایی</span>
                <div>
                  <shine-loading body_width="80" v-if="loading_get_balance" />
                  <debit-credit-display v-else-if="props.payment_able_selected?.payed"
                                        :amount="props.payment_able_selected.current_total_mandeh || 0" />

                  <debit-credit-display v-else :amount="total_mandeh" />

                </div>
              </div>
              <div class="tw-flex tw-justify-between tw-py-3 tw-px-6">
                <span class="tw-text-tiny">جمع مبالغ پرداخت شده</span>
                <div>
                  {{ new Intl.NumberFormat().format(sum_amount_payed) }} ریال
                </div>
              </div>
            </div>
          </transition>

          <!--   Other Detail   -->
          <div class="tw-mt-4">
            <div class="tw-py-4 tw-px-6">
              <p class="tw-text-blue-dark-200">بابت</p>
              <div>
                <shine-loading body_width="80" v-if="loading" />
                <template v-else>
                  <base-icon icon="history-edu" class="tw-pl-4 tw-align-middle" size="20" />
                  <span>{{ getPayForTitlePaymentAble(payment_able_selected) }}</span>
                </template>
              </div>
            </div>
            <div class="tw-py-4 tw-px-6">
              <p class="tw-text-blue-dark-200" @click="visible_send_sms_modal = true">بستانکار</p>
              <div>
                <shine-loading body_width="100" v-if="loading" />
                <template v-else>
                  <license-plate v-if="props.payment_able_selected?.creditorable?.car_number_base !== undefined" :car="props.payment_able_selected.creditorable" size="sm"/>
                  <div v-if="props.payment_able_selected?.creditorable?.first_name !== undefined">
                    <base-icon icon="account-circle" class="tw-pl-4 tw-align-middle" size="20" />
                    {{ mixin.methods.get_fullname(props.payment_able_selected.creditorable) }}
                  </div>
                </template>
              </div>
            </div>
            <div class="tw-py-4 tw-px-6">
              <p class="tw-text-blue-dark-200">کد حسابداری بستانکار</p>
              <div>
                <shine-loading body_width="120" v-if="loading" />
                <template v-else>
                  <base-icon icon="barcode" class="tw-pl-4 tw-align-middle" size="20" />
                  <span class="tw-inline-block">{{ props.payment_able_selected?.creditorable?.faramohaseb_id || '-/-' }}</span>
                </template>
              </div>
            </div>
            <div class="tw-py-4 tw-px-6">
              <p class="tw-text-blue-dark-200">موبایل بستانکار</p>
              <div>
                <shine-loading body_width="60" v-if="loading" />
                <template v-else>
                  <base-icon icon="mobile" class="tw-pl-4 tw-align-middle" size="20" />
                  <span class="tw-inline-block">{{ props.payment_able_selected?.creditorable?.mobile || '-/-' }}</span>
                </template>
              </div>
            </div>
            <div class="tw-py-4 tw-px-6">
              <p class="tw-text-blue-dark-200">کسری</p>
              <div>
                <base-icon icon="running-with-errors" class="tw-pl-3 tw-align-middle" size="20" />
                <shine-loading body_width="150" v-if="loading" />
                <template v-else-if="props.payment_able_selected?.order">
                  <span v-if="!props.payment_able_selected.order.ton_shortage">ندارد</span>
                  <span v-else>
                    تعداد
                    {{ props.payment_able_selected.order.ton_shortage * 20 }}
                    کیسه به مبلغ
                    {{
                      toNumberFormat(
                        (mixin.methods.get_price_per_ton_rial(props.payment_able_selected.order) +
                          props.payment_able_selected.order.price_rent +
                          props.payment_able_selected.order.price_reward || 0) *
                        props.payment_able_selected.order.ton_shortage
                      )
                    }}
                    ریال
                  </span>
                </template>
              </div>
            </div>
            <div class="tw-py-4 tw-px-6">
              <p class="tw-text-blue-dark-200">توضیحات</p>
              <div>
                <shine-loading body_width="190" v-if="loading" />
                <template v-else>
                  <base-icon icon="description" class="tw-pl-3" size="20" />
                  <div class="d-inline-block" v-if="props.payment_able_selected?.order_id">
                    <base-animated-text max-length="40">
                      <template #default>
                        <div class="d-inline-block" v-if="props.payment_able_selected.pay_for === 'order_to_payment'">
                          دستور پرداخت مبلغ ثابت
                          {{ toNumberFormat(payment_able_selected.amount) }} ریال
                        </div>
                        <div v-else-if="props.payment_able_selected?.order_id" class="fs-13">
                          {{props.payment_able_selected.pay_for_title }}
                          <div class="d-inline-block">
                            {{ props.payment_able_selected.order.ton_loaded }} تن
                          </div>
                          با فی
                          <div class="d-inline-block" v-if="props.payment_able_selected.pay_for === 'rent'">
                            {{ toNumberFormat(props.payment_able_selected.order.price_rent) }}
                          </div>
                          <div class="d-inline-block" v-else-if="props.payment_able_selected.pay_for === 'reward'">
                            {{ toNumberFormat(props.payment_able_selected.order.price_reward) }}
                          </div>
                          <div class="d-inline-block"  v-else-if="props.payment_able_selected.pay_for === 'rent_and_reward'">
                            {{
                              toNumberFormat(
                                props.payment_able_selected.order.price_rent +
                                props.payment_able_selected.order.price_reward,
                              )
                            }}
                          </div>
                          ریال
                        </div>
                      </template>
                    </base-animated-text>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!--   Right Side   -->
        <div class="rtl md:w-h-full tw-overflow-y-auto max-md:tw-py-10">
          <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-auto md:tw-h-full tw-overflow-y-auto">
            <div class="tw-w-[325px]">
              <!--    Bank Account Info    -->
              <show-bank-account-info :bank-information="props.payment_able_selected?.bank_information"
                                      @updatedBank="getPaymentable"
                                      :payment_able_id="props.payment_able_selected?.id || null"
                                      :loading="loading"/>

              <!--    Related Payments    -->
              <show-all-payment-small :payments="props.payment_able_selected?.payments" :loading="loading" />
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="c-pointer tw-text-primary-500" @click="showMoreDetailModal" >
        <template v-if="props.payment_able_selected?.order_id">
          <base-icon icon="info" class="fs-21 tw-align-middle tw-ml-3"></base-icon>
          <span class="tw-font-bold">اطلاعات بار</span>
        </template>
      </div>
      <div class="max-[395px]:tw-w-full tw-text-left">
        <new-btn variant="outline"
                 color="primary"
                 @click="close"
                 class="tw-ml-6">بستن
        </new-btn>
        <more-btn color="blue-dark" :loading="loading_online_payment || loading || loading_get_balance" :disabled="loading || loading_online_payment" label="انتخاب گزینه">
          <template #options>
            <template v-if="props.payment_able_selected?.cancel === 1">
              <li class="tw-px-4 tw-py-2 tw-text-blue-dark-200" v-if="props.payment_able_selected.payed">
                وضهیت این پرداختنی پرداخت شده است، و امکان بازگردانی از لغو نیست!
              </li>
              <li v-else
                  @click="undo_cancel_payment_able"
                  class="tw-px-4 tw-py-2 tw-cursor-pointer">
                <base-icon icon="cancel" size="20" class="tw-ml-2" />
                خروج از وضعیت لغو شده
              </li>
            </template>
            <template v-else>
              <more-btn-options :disabled="props.payment_able_selected?.payed || loading_online_payment
              // || amount_pay === 0
"
                                :loading="loading_online_payment"
                                text="پرداخت آنلاین"
                                @click="visible_verify_code_modal = true"
                                icon-name="credit-card"/>

              <more-btn-options :disabled="props.payment_able_selected?.payed === 1"
                                text="ثبت پرداخت"
                                :href="{ name: 'NewPayment', query: new_payment_queries_link }"
                                icon-name="add-card"/>

              <more-btn-options :disabled="props.payment_able_selected?.payed === 1 && !props.payment_able_selected?.payments.length"
                                text="ارسال مجدد پیامک پرداختی"
                                @click="visible_send_sms_modal = true"
                                icon-name="sms"/>

              <more-btn-options :disabled="props.payment_able_selected?.payed === 1"
                                text="لغو کردن"
                                @click="cancel_payment_able"
                                icon-name="cancel"/>

            </template>
          </template>
        </more-btn>
      </div>
    </template>
  </vertical-modal>

  <load-detail-small-modal :payment_able="props.payment_able_selected"
                           :visible="visible_load_detail"
                           @close="closedLoadDetailModal" />


  <send-sms-payment-able :visible="visible_send_sms_modal"
                         :payment_able="props.payment_able_selected"
                         @close="visible_send_sms_modal = false" />


  <confirm-verification-code-online-payment :visible="visible_verify_code_modal"
                                            :payment_able="props.payment_able_selected"
                                            :amount_pay="amount_pay"
                                            @confirmed="do_online_payment"
                                            @close="visible_verify_code_modal = false" />


</template>


<script setup>

import {computed, ref, getCurrentInstance, watch} from "vue";
import VerticalModal from "@/components/base/VerticalModal.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import MoreBtn from "@/components/base/btn/MoreBtn.vue";
import NewBtn from "@/components/base/btn/NewBtn.vue";
import TearCard from "@/components/base/more/TearCard.vue";
import Currency from "@/components/partial/Currency.vue";
import VerticalShowing from "@/components/base/animations/VerticalShowing.vue";
import DebitCreditDisplay from "@/components/base/more/DebitCreditDisplay.vue";
import useClipboard from "vue-clipboard3";
import mixin from  '@/mixin'
import ShineLoading from "@/components/loading/ShineLoading.vue";
import ShowMandeh from "@/components/partial/ShowMandeh.vue";
import LicensePlate from "@/components/partial/LicensePlate.vue";
import ShowAllPaymentSmall from "@/components/paymentable/ShowAllPaymentSmall.vue";
import ShowBankAccountInfo from "@/components/paymentable/ShowBankAccountInfo.vue";
import {useRoute} from 'vue-router'
import Swal from "sweetalert2";
import BaseAnimatedText from "@/components/base/BaseAnimatedText.vue";
import InputAyandeh from "@/components/inputs/InputAyandeh.vue";
import SendSmsPaymentAble from "@/components/paymentable/SendSmsPaymentAble.vue";
import MoreBtnOptions from "@/components/base/btn/MoreBtnOptions.vue";
import LoadDetailSmallModal from "@/components/paymentable/LoadDetailSmallModal.vue";
import { apiDoOnlinePayment, apiUndoCanceledPaymentAble, apiCancelPaymentAble, getPayForTitlePaymentAble } from '@/services/paymentable/PaymentAble'
import ConfirmVerificationCodeOnlinePayment from "@/components/paymentable/ConfirmVerificationCodeOnlinePayment.vue";

const route = useRoute()
const { proxy } = getCurrentInstance()
const showMoreDetail = ref(false);
const other_detail = ref(null)
const sum_payment_able_amount = ref(0)
const sum_payment_able_amount_loading = ref(false)
const visible_load_detail = ref(false)
const loading = ref(false)
const cancel_loading = ref(false)
const undo_cancel_loading = ref(false)
const code_balance = ref(null)
const loading_get_balance = ref(false)
const visible_send_sms_modal = ref(false)
const visible_verify_code_modal = ref(false)
const loading_online_payment = ref(false)

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  payment_able_selected: {
    type: [Object, null],
    required: true,
  }
});

const emit = defineEmits([
  "update:modelValue",
  'close',
  'refresh_list',
  'update:payment_able_selected'
])

const undo_cancel_payment_able = () => {

  proxy.$showConfirm(
    {
      title: 'بازگردانی از لغو',
      confirm_text: 'بازگردانی شود',
      text: 'آیا میخواهید این سند پرداختنی را از وضعیت لغو شده خارج کنید؟',
      icon: 'question',
    },
    async () => {
      undo_cancel_loading.value = true
      try {
        const response = await apiUndoCanceledPaymentAble(props.payment_able_selected?.id)

        if(data.status === 'success') {
          emit('update:payment_able_selected', response.data.payment_able)
          emit('refresh_list', response.data.payment_able)
          proxy.$toast(data.message, response.data.status)
        }
      } catch (e) {} finally {
        undo_cancel_loading.value = false
      }
    }
  )


}


const close = () => {
  resetModalData()
  openModal.value = false
  emit('close', true)
}

const openModal = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    if (value !== props.modelValue) {
      emit("update:modelValue", value);
    }
  },
});


const showMoreDetailModal = () => {
  visible_load_detail.value = true
}
const closedLoadDetailModal = () => {
  visible_load_detail.value = false
}


const resetModalData = () => {
  sum_payment_able_amount.value = 0
  code_balance.value = null
}
const getPaymentable = async () => {
  if(!props.payment_able_selected?.id) return false
  loading.value = true
  try {
    const response = await axios.get('/paymentable/get?id=' + props.payment_able_selected?.id);

    if (response.data?.status === 'success') {
      emit('update:payment_able_selected', response.data.payment_able)
      emit('refresh_list', response.data.payment_able)
      get_sum_creditorable_amount()

      if(props.payment_able_selected?.creditorable?.faramohaseb_id) {
        loading_get_balance.value = true
        get_code_balance(props.payment_able_selected.creditorable.faramohaseb_id)
      }
    }

  } catch (error) {
    proxy.$toast(error.message, 'error')
  } finally {
    loading.value = false;
  }
}

const get_sum_creditorable_amount = async () => {
  if(!props.payment_able_selected?.id) return false

  sum_payment_able_amount_loading.value = true
  try {
    const response = await axios.get('/paymentable/get_sum_creditorable_amount/' + props.payment_able_selected?.id)

    if (response?.data?.status === 'success') {
      sum_payment_able_amount.value = response.data.sum_amount
    }
  } catch (e) {} finally {
    sum_payment_able_amount_loading.value = false
  }
}

const cancel_payment_able = () => {
  proxy.$showConfirm(
    {
      title: 'لغو پرداختنی',
      confirm_text: 'لغو پرداختنی',
      text: 'آیا از لغو این سند پرداختنی اطمینان دارید؟',
      icon: 'warning',
    },
    async () => {
      cancel_loading.value = true
      try {
        const response = await apiCancelPaymentAble(props.payment_able_selected?.id)

        const data = response.data
        if (data?.status === 'success') {
          emit('update:payment_able_selected', data.payment_able)
          emit('refresh_list', data.payment_able)

          proxy.$toast(data.message, data.status)
        }
      } catch (e) {} finally {
        cancel_loading.value = false
      }
    }
  )
}


// Computed
const sum_amount_payed = computed(() => {
  return mixin.methods.calc_sum_amount_payed(props.payment_able_selected)
})

const amount_pay = computed(() => {
  const calc1 = (props.payment_able_selected?.amount || 0) - sum_amount_payed.value
  const amount = total_mandeh.value > 0 ? calc1 - total_mandeh.value : calc1
  return Math.round(amount, 0)
})


const total_mandeh = computed(() => {
  if(props.payment_able_selected) {
    return (
      sum_payment_able_amount.value +
      (code_balance.value || 0)
    )
  }
  return 0
})

const new_payment_queries_link = computed(() => {
  if(props.payment_able_selected) {
    return {
      bed_id: props.payment_able_selected.creditorable.faramohaseb_id,
      payment_able_id: props.payment_able_selected?.id,
      amount: amount_pay.value,
      bes_id: 101010009,
      type_payment_selected: 3,
      type_pay_selected: 'naghdi',
      redirect: route.fullPath,
    }
  }
  return {}
})

watch(openModal, (newValue) => {
  if (newValue) {
    // getPaymentable()
    get_sum_creditorable_amount()

    if(props.payment_able_selected?.creditorable?.faramohaseb_id) {
      loading_get_balance.value = true
      get_code_balance(props.payment_able_selected.creditorable.faramohaseb_id)
    }
  }
})

const get_code_balance = (code_id) => {
  loading_get_balance.value = true
  axios.get('/get_code_mandeh/' + code_id).then((respponse) => {
    if(respponse?.data) {
      code_balance.value = respponse.data.mandeh
    }
    loading_get_balance.value = false
  })
}


const do_online_payment = async (verification_code) => {
  loading_online_payment.value = true
  try {
    const response = await apiDoOnlinePayment(props.payment_able_selected.id, {
      amount_paymentable: amount_pay.value,
      code: verification_code
    });

    const data = response.data
    proxy.$my_alert(data.message, data.success ? "success" : "error");

    if (data.success) {
      await getPaymentable();
    }

  } catch (error) {
    console.error(error);
  } finally {
    loading_online_payment.value = false
  }
}

</script>


<style scoped>

.price-detail-enter-active,
.price-detail-leave-active {
  transition: all 0.4s cubic-bezier(0.5,1.25,.5,1);
}

.price-detail-enter-from,
.price-detail-leave-to {
  opacity: 0;
  height: 0;
  overflow: hidden;
}

.price-detail-enter-to,
.price-detail-leave-from {
  opacity: 1;
  height: auto;
  overflow: hidden;
}

.swal2-cancel {
  border: 1px
}
</style>
<script setup>
</script>
